import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore";
import { SavedActivity, SavedComponentSkill } from "./SavedResourcesContext";

export const fetchSavedResources = async (userId: string) => {
  const db = getFirestore();
  const savedResourcesRef = doc(db, "savedResources", userId);
  const savedResources = await getDoc(savedResourcesRef);

  if (!savedResources.exists()) return { componentSkills: [], activities: [] };

  const { componentSkills = [], activities = [] } = savedResources.data();
  return {
    componentSkills,
    activities,
  };
};

export const updateSavedComponentSkills = async (
  userId: string,
  componentSkills: SavedComponentSkill[],
) => {
  const db = getFirestore();
  const savedResourcesRef = doc(db, "savedResources", userId);

  return await setDoc(savedResourcesRef, { componentSkills }, { merge: true });
};

export const updateSavedActivities = async (
  userId: string,
  activities: SavedActivity[],
) => {
  const db = getFirestore();
  const savedResourcesRef = doc(db, "savedResources", userId);
  return await setDoc(savedResourcesRef, { activities }, { merge: true });
};
